<div class="common-modal__container">
  <div class="common-modal__header">
    <span class="common-modal__text-header"
      [afTranslate]="'law-info.legal-references'">_Documentación jurídica
    </span>
  </div>
  <legal-document class="common-modal__content"
    [references]="references"
    [selected]="lawInfo.selected"
    [registerEvent]="registerEvent">
  </legal-document>
  <div class="common-modal__footer">
    <button [ngClass]="lawInfo.selected?.type === 'form'?'common-button__text-noborder':'common-button__text-border'"
      (click)="handleDismiss()">
      <span class="common-button__text-title"
        [afTranslate]="'common.close'">_Cerrar
      </span>
    </button>
    @if (lawInfo.selected) {
      @if (lawInfo.selected.type === 'form') {
        <button class="common-button__text-border"
          (click)="openDB()">
          <span class="common-button__text-title"
            [afTranslate]="'law-info.see-form-bd'">_Ver formulario en B.D. Juridica
          </span>
        </button>
      }
      <button class="common-button__text"
        (click)="printAction()">
        <span class="common-button__text-title"
          [afTranslate]="'common.print'">_Imprimir
        </span>
      </button>
    }
  </div>
</div>
